import { useRef, useEffect } from 'react';

export function usePrev<T>(value: T): T {
    const ref = useRef({} as T);
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}
